import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit, OnChanges {
  @Input() paramChave: boolean = true;
  @Input() loadingEmpresa: boolean = false;
  @Input() logoBase64: any;

  logo: any;

  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.renderLogo();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.renderLogo();
  }

  private renderLogo() {
    this.logo = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.logoBase64);
  }

}
